import { observer } from 'mobx-react';
import * as style from './NoResultsFound.module.less';

export const NoResultsFound = observer(() => {
    return (
        <div className={style.container}>
            <div className={style.iconContainer}>
                <i className={`bi bi-search ${style.searchIcon}`}></i>
            </div>
            <div className={style.title}>No Results Found</div>
            <div className={style.message}>
                Your search is too narrow. Try adjusting the filters or search parameters.
            </div>
        </div>
    );
}); 